import React from "react";

const IndvReduction = () => {
    return (
        <div>
            <iframe
                id="A"
                src="https://extra-util.aonecustoms.com/?dropdown=IndvReduction"
                style={{ width: "100%", height: "100vh", border: "none" }}
                title="Extra Util"
                onLoad={() => {
                    const iframe = document.getElementById("A");
                    iframe?.contentWindow?.postMessage(
                        { type: "TOKEN", token: localStorage.getItem("access_Token") },
                        "https://extra-util.aonecustoms.com/"
                    );
                }}
            />
        </div>
    );
};

export default IndvReduction;
